class MobileDrawerAccordion extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('.mobile-menu-details');
    this.summary = this.querySelector('.mobile-menu-trigger');
    this.drawer = this.querySelector('.mobile-drawer-accordion');
    this.closeBtn = this.querySelector('.mobile-drawer-accordion__close');
    this.overlay = this.querySelector('.mobile-drawer-accordion__overlay');
    this.isClosing = false;
    
    this.bindEvents();
    this.bindAccordionEvents();
  }

  bindEvents() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
    
    if (this.details) {
      this.details.addEventListener('toggle', (e) => {
        if (this.isClosing) return;
        if (e.target.open) this.open();
      });
      
      this.summary.addEventListener('click', (e) => {
        if (this.details.open && !this.isClosing) {
          e.preventDefault();
          this.close();
        }
      });
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.details && this.details.open && !this.isClosing) {
        this.close();
      }
    });
  }

  bindAccordionEvents() {
    const accordions = this.querySelectorAll('.mobile-drawer-accordion__accordion');
    
    accordions.forEach(accordion => {
      const summary = accordion.querySelector('summary');
      
      if (summary) {
        summary.addEventListener('click', (e) => {
          if (accordion.open && !accordion.isClosing) {
            e.preventDefault();
            this.closeAccordion(accordion);
          }
        });
      }
    });
  }

  closeAccordion(accordion) {
    if (accordion.isClosing) return;
    accordion.isClosing = true;
    
    accordion.classList.add('closing');
    
    const summary = accordion.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
    
    setTimeout(() => {
      accordion.open = false;
      accordion.classList.remove('closing');
      accordion.isClosing = false;
    }, 300);
  }

  open() {
    this.isClosing = false;
    document.body.classList.add('mobile-drawer-open');
    this.details.classList.add('menu-opening');
    this.details.classList.remove('menu-closing');
    
    if (this.summary) {
      this.summary.setAttribute('aria-expanded', 'true');
    }
  }

  close() {
    if (this.isClosing) return;
    this.isClosing = true;
    
    this.details.classList.add('menu-closing');
    this.details.classList.remove('menu-opening');
    
    document.body.classList.remove('mobile-drawer-open');
    
    if (this.summary) {
      this.summary.setAttribute('aria-expanded', 'false');
    }

    setTimeout(() => {
      if (this.details) {
        this.details.open = false;
        this.details.classList.remove('menu-closing');
      }
      this.isClosing = false;
    }, 300);
  }
}

 if (!customElements.get('header-drawer')) {
   customElements.define('header-drawer', MobileDrawerAccordion);
 }